import { getCodebookEntrySuggestions } from '@/api/generated/codebooks/codebooks';
import type { CodebookEntrySuggestion, ListRequest } from '@/api/generated/schemas';
import {
  defineEntityAsyncSelector,
  listRequestQueryKey,
  selectorPresets,
  toListRequest,
  type NoPickFilters,
} from '@/shared/ui/async-selector';

const PRODUCT_TYPE_FOLDER = 'ProductType';

export interface WebFilterProductTypeRef {
  id: number;
  name: string;
  code: string | null;
}

export const productTypeSelector = defineEntityAsyncSelector<
  WebFilterProductTypeRef,
  CodebookEntrySuggestion,
  ListRequest,
  NoPickFilters
>({
  api: {
    fetch: getCodebookEntrySuggestions,
    buildApiParams: (ctx) =>
      toListRequest(ctx.search, ctx.ids, [
        { field: 'folder', text: PRODUCT_TYPE_FOLDER },
        ...(ctx.extraFilters ?? []),
      ]),
    queryKey: (request) => listRequestQueryKey(`www.web-filters.productTypes`, request),
    mapItem: (s) => ({ id: s.id, name: s.name ?? '', code: s.code ?? null }),
  },
  key: (item) => item.id,
  display: {
    kind: 'nameCode',
    name: (item) => item.name,
    code: (item) => item.code,
  },
  columns: (t) =>
    selectorPresets.nameAndCode({
      name: {
        id: 'name',
        header: t('webFilter.criteria.selectors.columns.name'),
        value: (item) => item.name,
        sortable: true,
      },
      code: {
        id: 'code',
        header: t('webFilter.criteria.selectors.columns.code'),
        value: (item) => item.code,
        emptyDash: '—',
      },
    }),
  i18n: { namespace: 'www' },
});
